import * as React from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// import Swiper styles
import 'swiper/scss'
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './../../ranking.css';

// const dlsitePopulars = require("./dlsiteRank.json")
// const fanzaPopulars = require("./dmmRank.json")



export default function RankingCompoment(props: {}) {

  const [dlsitePopulars, setDlsitePopulars] = React.useState({} as any)
  const [fanzaPopulars, setFanzaPopulars] = React.useState({} as any)

  const [showTypeForDlsite, setShowTypeForDlsite] = React.useState(null as {
    type: string,
    title: string
  })

  const [showTypeForFanza, setShowTypeForFanza] = React.useState(null as {
    type: string,
    title: string
  })



  const getTitleForDlsite = (number: Number) => {
    if (number === 1) {
      return {
        type: "doujin",
        title: "DLSite同人7日間人気ランキング"
      }
    } else if (number === 2) {
      return {
        type: "comic",
        title: "DLSiteコミック7日間人気ランキング"
      }
    } else {
      return {
        type: "game",
        title: "DLSite美少女ゲーム7日間人気ランキング"
      }
    }
  }

  const getTitleForFanza = (number: Number) => {
    if (number === 1) {
      return {
        type: "doujin",
        title: "Fanza同人7日間人気ランキング"
      }
    } else if (number === 2) {
      return {
        type: "ebook",
        title: "Fanzaコミック7日間人気ランキング"
      }
    } else {
      return {
        type: "pcgame",
        title: "Fanza美少女ゲーム7日間人気ランキング"
      }
    }
  }

  const isSmartphone = () => navigator.userAgent.match(/iPhone|Android.+Mobile/) ? true : false

  React.useEffect(() => {
    const loadRanking = async () => {
      const targetNumber = isSmartphone() ? Math.floor(Math.random() * 2) + 1 : Math.floor(Math.random() * 3) + 1
      // TOOD: 開発時はこちらを使う
      // setDlsitePopulars(require("./dlsiteRank.json"))
      // setFanzaPopulars(require("./dmmRank.json"))
      setDlsitePopulars(JSON.parse(await fetch(process.env.REACT_APP_URL + "api/wp/getRankDLSite").then(res => res.json())))
      setFanzaPopulars(JSON.parse(await fetch(process.env.REACT_APP_URL + "api/wp/getRankDMM").then(res => res.json())))
      setShowTypeForDlsite(getTitleForDlsite(targetNumber))
      setShowTypeForFanza(getTitleForFanza(targetNumber))

    }

    loadRanking()

  }, [])


  if (!showTypeForDlsite || !showTypeForFanza) return <></>

  return (
    <>
      <div className="block-title">{showTypeForDlsite?.title}</div>
      <div>※ブラウザが対応していれば横スクロールできます</div>
      <Swiper
        spaceBetween={10}
        slidesPerView={3}
        navigation
        modules={[Navigation]}
      // onSlideChange={() => console.log('slide change')}
      // onSwiper={(swiper) => console.log(swiper)}
      >
        {dlsitePopulars[showTypeForDlsite?.type]?.map((dlsitePopular, index) => (
          <SwiperSlide className="swiper-slide" key={`dlsite${index}`}>
            <div className="rank_number">
              <span>{index + 1}位</span>
            </div>
            <div className="post__thumb--img">
              <span dangerouslySetInnerHTML={{ __html: dlsitePopular["img"] }}></span>
            </div>
            <div className="title-text">
              {dlsitePopular["title"]}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>



      <div className="block-title">{showTypeForFanza?.title}</div>
      <div>※ブラウザが対応していれば横スクロールできます</div>
      <Swiper
        spaceBetween={10}
        slidesPerView={3}
        navigation
        modules={[Navigation]}
      // onSlideChange={() => console.log('slide change')}
      // onSwiper={(swiper) => console.log(swiper)}
      >
        {fanzaPopulars[showTypeForFanza?.type]?.map((fanzaPopular, index) => (
          <SwiperSlide className="swiper-slide" key={`fanza${index}`}>
            <div className="rank_number">
              <span>{index + 1}位</span>
            </div>
            <div className="post__thumb--img">
              <a href={fanzaPopular["url"]}><img src={fanzaPopular["imageURL"]} /></a>
            </div>
            <div className="title-text">
              {fanzaPopular["title"]}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
